<template>
  <div class="bulk-order-gift-cards-show">
    <div class="container-header">
      <PageHeadlineForBulkOrder
        class="gift-card-header"
        title="プレビュー"
        :show-stepper="false"
        :button-type="ButtonType.LINK"
        :button-label="patternTitle"
      />
    </div>
    <div class="bulk-order-gift-cards-show__content">
      <Preview
        :card-design-image-url="imageUrl"
        :sender-name="senderName"
        :profile-link="false"
        :message="message"
        :item-sku-contents="itemSkuContentAttributes"
      />
    </div>
    <div class="bulk-order-gift-cards-show__bottom">
      <div class="bulk-order-gift-cards-show__bottom--actions">
        <a class="btn btn--primary" href="/bulk_order/gift_cards">
          ギフトカードリストに戻る
        </a>
        <button class="text-link-to-top" @click="onClickGiftCardEditPage">
          ギフトカードを編集する
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import PageHeadlineForBulkOrder, {
  ButtonType
} from '../../../organism/bulk_personal_orders/PageHeadlineForBulkOrder.vue'
import Preview from '../../../molecules/gift_card/Preview.vue'
import { useBulkPersonalOrderSessionGiftCardStore } from '../../../../store/bulkPersonalOrderSessionGiftCard'
import { computed } from 'vue'

const props = defineProps({
  giftCardSessionToken: {
    type: String,
    required: true
  },
  patternTitle: {
    type: String,
    required: true
  },
  cardDesignImageUrl: {
    type: String,
    required: false,
    default: ''
  },
  personalGiftCardDataUri: {
    type: String,
    required: false,
    default: ''
  },
  message: {
    type: String,
    required: false,
    default: ''
  },
  senderName: {
    type: String,
    required: true
  },
  itemSkuContentAttributes: {
    type: Array,
    required: true
  }
})

const store = useBulkPersonalOrderSessionGiftCardStore()
const { deleteGiftCard } = store

const imageUrl = computed(() =>
  props.cardDesignImageUrl !== ''
    ? props.cardDesignImageUrl
    : props.personalGiftCardDataUri
)

const onClickGiftCardEditPage = () => {
  // プレビューから編集を行う場合は、編集中のデータを削除する
  deleteGiftCard(props.giftCardSessionToken)
  window.location.href = `/bulk_order/gift_cards/${props.giftCardSessionToken}/edit`
}
</script>

<style lang="scss" scoped>
.bulk-order-gift-cards-show {
  .container-header {
    display: flex;
    justify-content: center;
    background-color: $white;
    margin-bottom: 16px;
  }

  .gift-card-header {
    max-width: $small-contents-width;
    width: 100%;
    padding: 24px 16px;
  }

  &__content {
    margin: 0 auto;
    max-width: $small-contents-width;
  }

  &__bottom {
    max-width: $small-contents-width;
    margin: 0 auto;

    &--actions {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      gap: 32px;
      margin-top: 16px;
      padding: 40px 16px;
      background-color: $white;
    }
  }
}
</style>
